module.exports = __webpack_public_path__ + "728ff5a8e44d74cd0f2359ef0a9ec88a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/TechSkills/icons/Git.png
// module id = 39
// module chunks = 0